export { default } from './FirstScene';
